import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const CommunicationsService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  service.getCommunicationPreferences = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/communications/preferences${queryString}`, {
      headers,
    });
  };

  return service;
})();

export default CommunicationsService;
